module.exports = __webpack_public_path__ + "img/YVC-Logo-Color.86c19651.svg";